import React from 'react';
import { ArrowRight, Check } from 'lucide-react';

const perks = [
  'Tilgang til alle treningsvideoer',
  'Sunne kostholdsplaner inkludert',
  'Kan avsluttes når som helst',
  'Tilgjengelig på alle enheter',
];

const CTA = () => {
  return (
    <section className="py-24 bg-gradient-cta relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `radial-gradient(circle at 10% 50%, #ffffff 0%, transparent 50%),
                            radial-gradient(circle at 90% 50%, #ffffff 0%, transparent 40%)`,
        }}
      />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-block bg-white/15 border border-white/25 rounded-full px-4 py-1.5 text-white text-sm font-medium mb-6">
          Bli sterkere i dag
        </span>

        <h2 className="text-4xl lg:text-6xl font-black text-white font-heading leading-tight mb-6">
          Ta kontroll over{' '}
          <span className="block text-white/90">treningen din nå!</span>
        </h2>

        <p className="text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Bli med i Workout ON og lås opp alt du trenger for å holde deg i form –
          treningsvideoer, kostholdsplaner, musikk og mye mer.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-10">
          {perks.map((perk, i) => (
            <div key={i} className="flex items-center space-x-2 text-white/90 text-sm">
              <Check className="w-4 h-4 text-white shrink-0" />
              <span>{perk}</span>
            </div>
          ))}
        </div>

        <a
          href="/s"
          className="inline-flex items-center gap-3 bg-white text-primary hover:bg-green-50 px-10 py-5 rounded-xl font-black text-xl transition-all duration-200 shadow-2xl hover:-translate-y-1 hover:shadow-3xl"
        >
          Fortsett
          <ArrowRight className="w-6 h-6" />
        </a>

        <div className="mt-6 space-y-1">
          <p className="text-white/90 text-sm font-semibold">Abonnement kr 39,-/uke.</p>
          <p className="text-white/75 text-sm">
            Avslutt abonnement ved å sende <strong className="text-white">WO STOPP</strong> til 2210.&nbsp;
            Hjelp: +4721955881
          </p>
        </div>

        <div className="mt-8 max-w-2xl mx-auto bg-white/10 rounded-xl p-5 border border-white/15">
          <p className="text-white/60 text-xs leading-relaxed text-left">
            Kunden registrerer sitt mobilnummer og bekrefter registreringen og ytterligere kostnader
            ved å taste inn PIN-koden som mottas via SMS. Dette er en abonnementstjeneste som
            automatisk fornyes hver måned. For å be om at tjenesten avsluttes, kan du kontakte
            kundeservice på +4721955881 eller sende en e-post til no@workout-on.com. Transaksjonen
            vil belastes telefonregningen din eller trekkes automatisk fra forhåndsbetalt saldo. Du
            kan når som helst avslutte abonnementet ved å sende en SMS til 2210 med kodeordet WO
            STOPP. Dersom tjenesten ikke avsluttes, vil den automatisk fornyes for en måned til.
            Aldersgrensen er 18 år. Tjenesten leveres av Skillbill B.V.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
